import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['currency', 'lang'])
  }
}